<template>
  <div class="safety-number safety-number--view">
    <button
      class="safety-number--remove-button"
      @click.prevent="removeNumber()"
    >
      <img
        src="@/assets/svg/trashcan.svg"
        width="20"
        height="20"
        alt="Muokkaa"
      />
    </button>
    <span class="pretty-number"> {{ model.fafNumber | PrettyNumber }} </span>
  </div>
</template>

<script>
import PrettyNumber from '@/filters/PrettyNumber';

export default {
  props: ['number', 'model'],
  filters: {
    PrettyNumber,
  },
  computed: {},
  methods: {
    removeNumber() {
      this.$emit('remove-number', this.model.fafNumber);
    },
    focusInput() {
      console.log(this.$refs.number.$el);
      // this.$refs.number.$el.focus();
    },
    saveNumber() {
      console.log('save number');
    },
    cancel() {
      console.log('cancel');
    },
  },
};
</script>

<style lang="scss">
.safety-number {
  &--view {
    margin: 0.5rem 0;
  }

  &--remove-button {
    float: right;
    padding-top: 2px;
    background: none;
  }

  .pretty-number {
    @include font-black();
    font-size: 1.2rem;
  }
}
</style>
